/** Coach pédagogique (chatbot) et explication du simulateur. */
import type { ChatContext, ChatMessage, ChatSession, LearningMode, ProgrammingLanguage } from '@unity-learning/shared';
import { apiPost, apiPut } from './client';

/** Délai d'ouverture d'une session : au-delà, message « connexion trop longue ». */
const SESSION_TIMEOUT_MS = 10_000;

export function getOrCreateChatSession(exerciseId: string): Promise<ChatSession> {
  return apiPost<ChatSession>('/api/chat/sessions', { exerciseId }, { timeoutMs: SESSION_TIMEOUT_MS });
}

export interface ChatReply {
  userMessage: ChatMessage;
  assistantMessage: ChatMessage;
  suggestions: string[];
}

/** 1 appel Gemini. */
export function sendChatMessage(params: {
  sessionId: string;
  exerciseId: string;
  message: string;
  context: ChatContext;
}): Promise<ChatReply> {
  return apiPost<ChatReply>('/api/chat/message', params);
}

export function closeChatSession(sessionId: string): Promise<void> {
  return apiPut<void>(`/api/chat/sessions/${encodeURIComponent(sessionId)}/close`);
}

export interface ExplainUnsupportedParams {
  userId: string;
  exerciseId: string;
  learningMode: LearningMode;
  programmingLanguage: ProgrammingLanguage;
  /** Remise au LLM produite par `toLlmHandoff` du simulateur. */
  handoff: unknown;
  studentCode: string;
}

/** Explication du coach pour un symbole hors périmètre du simulateur (1 appel Gemini). */
export function explainUnsupported(params: ExplainUnsupportedParams): Promise<string> {
  return apiPost<{ explanation: string }>('/api/chat/explain-unsupported', params).then((data) => {
    if (!data?.explanation) throw new Error('Le Coach n\'a pas renvoyé d\'explication.');
    return data.explanation;
  });
}
